var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowDownDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11.8px",
    height: "6.8px",
    viewBox: "0 0 11.8 6.8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5\\uFE0F-Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gestionnaire---Paiements---Volets-ferm\\xE9s",
    transform: "translate(-1440.100000, -396.600000)",
    stroke: "#030303",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(152.000000, 381.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1294.000000, 19.000000) rotate(-360.000000) translate(-1294.000000, -19.000000) translate(1284.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "5 7.5 10 12.5 15 7.5"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDownDark);
export default __webpack_public_path__ + "static/media/icon_arrow_down_dark.8ea0749ee111cc53f2ef217f9d1fecff.svg";
export { ForwardRef as ReactComponent };